// extracted by mini-css-extract-plugin
export var text = "_y-0";